const covid = {
    "Global": {"NewConfirmed":175328,"TotalConfirmed":116996189,"NewDeaths":4064,"TotalDeaths":2597998,"NewRecovered":165432,"TotalRecovered":66343498,"Date":"2021-03-09T12:36:21.556Z"},
    "Israel" : {"CountryCode":"IL","Slug":"israel","NewConfirmed":5111,"TotalConfirmed":805116,"NewDeaths":25,"TotalDeaths":5917,"NewRecovered":4521,"TotalRecovered":761326,"Date":"2021-03-09T12:36:21.556Z"}
}
export default covid;